import React, { useState } from 'react';
import AceEditor from 'react-ace';
import axios from 'axios'; // Ensure axios is installed
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/mode-text'; // Added for explanation display
import 'ace-builds/src-noconflict/theme-github';
import './sqltutorial.css'; // Your custom CSS

function SqlExplainer() {
  const [query, setQuery] = useState('');
  const [explanation, setExplanation] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const sqlexplainer = async () => {
    try {
      if (isLoading){
        return
      }
      setIsLoading(true);
      const response = await axios.post('https://us-central1-explo-website-tools.cloudfunctions.net/explainSQLQuery', { query });
      setExplanation(response.data.explanation);
      setIsLoading(false);
    } catch (error) {
      console.error('Error explaining SQL:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="app-container">
      <h1>SQL Explainer</h1>
      <div className="query-input">
        <AceEditor
          mode="sql"
          theme="github"
          name="queryEditor"
          value={query}
          wrapEnabled={true}
          onChange={setQuery}
          fontSize={14}
          showPrintMargin={true}
          showGutter={true}
          highlightActiveLine={true}
          setOptions={{
            enableBasicAutocompletion: false,
            enableLiveAutocompletion: false,
            enableSnippets: false,
            showLineNumbers: true,
            tabSize: 2,
          }}
          style={{ width: '100%', minHeight: '50px', maxHeight: '150px' }}
        />
        <button onClick={sqlexplainer} style={{ marginTop: '10px' }}>Explain SQL</button>
        {isLoading && <p>Loading explanation...</p>}
      </div>
      {explanation && (
        <div className="explanation-output">
          <h2>Explanation</h2>
          <AceEditor
            mode="text"
            theme="github"
            name="explanationEditor"
            value={explanation}
            wrapEnabled={true}
            fontSize={14}
            readOnly={true}
            showPrintMargin={false}
            showGutter={true}
            highlightActiveLine={false}
            setOptions={{
              showLineNumbers: false,
              tabSize: 2,
            }}
            style={{ width: '100%', minHeight: '50px', maxHeight: '150px' }}
          />
        </div>
      )}
    </div>
  );
}

export default SqlExplainer;